// @core/api/endpoints/calendar/update_booking_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLinkResponse,
  UpdateBookingLinkRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update booking link
 * Updates booking link settings including availability, duration, buffer times, and form questions.
 */
export async function UpdateBookingLink(
  link_id: string,
  data: UpdateBookingLinkRequest,
  options?: RequestOptions
): Promise<BookingLinkResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-links/:link_id`;
  requestPath = requestPath.replace(':link_id', encodeURIComponent(link_id));
  const requestOptions = options;
  return client.put<BookingLinkResponse>(requestPath, data, requestOptions);
}
